export default "__VITE_ASSET__CcWZQWQY__"